import _ from "lodash";
import { normalizeCnpj } from "@/utils/documents.js";

const keepExistingValue = (a, b) => (a ? a : b);

/**
 * Executes a deep merge on any object,
 * but keeps the value of left object.
 */
const mergeDeepKeepLeftWith = (a, b) =>
  _.mergeWith(a, b, (a, b) =>
    _.isObject(a) || _.isObject(b)
      ? _.mergeWith(a, b, keepExistingValue)
      : keepExistingValue(a, b)
  );

/**
 * This mixin require that the component has a computed
 * property `cloneModel`, to be used when merging with
 * what is coming from the API, and, a method called
 * `updateModel` to properly set the new model.
 *
 * This is required to make objects inside the model
 * reactive.
 */
export default {
  methods: {
    mergeProperties(oldValue, newValue) {
      return mergeDeepKeepLeftWith(oldValue, newValue);
    },
    mergePropertiesReplacing(oldValue, newValue) {
      return _.merge(oldValue, newValue);
    },
    findCNAEProxy(cep) {
      this.withLoading(this.findCNAE(cep)).then(this.mergeCNAE);
    },
    findCEPProxy(cep) {
      this.withLoading(this.findCEP(cep)).then(this.mergeCEP);
    },
    findLegalPersonProxy(cnpj) {
      this.withLoading(this.findLegalPerson(normalizeCnpj(cnpj))).then(
        this.mergeLegalPerson
      );
    },
    mergeLegalPerson(value) {
      let model = this.cloneModel;
      value.atividade_principal = value.atividades.filter(
        e => e.atividade_principal
      )[0];
      value = _.pick(value, [
        "nome",
        "nome_fantasia",
        "razao_social",
        "endereco",
        "atividade_principal"
      ]);
      this.oldCNAE = value.atividade_principal.codigo;
      this.updateModel(this.mergePropertiesReplacing(model, value));
    },
    mergeCEP(value) {
      let model = this.cloneModel;

      this.updateModel(this.mergeProperties(model.endereco, value.endereco));
    },
    mergeCNAE(value) {
      if (value.length == 0) return;
      let model = this.cloneModel;
      let newValue = { atividade_principal: value[0] };
      newValue.atividade_principal.nome =
        newValue.atividade_principal.descricao;
      this.oldCNAE = newValue.atividade_principal.codigo;
      this.updateModel(this.mergePropertiesReplacing(model, newValue));
    }
  }
};
